import React, { Component } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Table,
  Row,
  Col,
  UncontrolledTooltip
} from "reactstrap";
import MembresiaIntegranteAlta from "../../../../types/MembresiaIntegranteAlta";
import MembresiaIntegranteResolucion from "../../../../types/MembresiaIntegranteResolucion";
import { formatIsoDate, formatMoney } from "../../../helpers/formatters";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import FormBuilderModal from "../../common/formBuilderModal/formBuilderModal";
import { resolucionAltaFormConfig } from "./IntegranteResolucionAlta.form";
import s from "./styles.scss";
import { Styled } from "../../../../toolkit/decorators/Artifact";

interface Props {
  alta: MembresiaIntegranteAlta;
  onResolverAlta?: (resolucion: MembresiaIntegranteResolucion) => Promise<any>;
  processingResolucion?: boolean;
}

interface State {
  resolucionModalOpen: boolean;
}

@Styled(s)
export default class IntegranteResolucionAlta extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      resolucionModalOpen: false
    };
  }

  handleOpenResolucionModal = () => {
    this.setState({ resolucionModalOpen: true });
  };

  handleCancelResolucion = () => {
    this.setState({ resolucionModalOpen: false });
  };

  handleSubmitResolucion = async (values: any) => {
    const { alta, onResolverAlta } = this.props;

    if (onResolverAlta) {
      const resolucion: MembresiaIntegranteResolucion = {
        idCotizacionItem: alta.idCotizacionItem,
        pagoForzado: values.pagoForzado || false,
        observaciones: values.observaciones || ""
      };

      await onResolverAlta(resolucion);

      this.setState({
        resolucionModalOpen: false
      });
    }
  };

  render() {
    const { alta } = this.props;

    return (
      <Card className="mb-3">
        {/* Descripción del cargo */}
        <CardHeader>
          <span
            style={
              !!alta.idMembresiaSocioPersona
                ? {
                    fontWeight: "bold"
                  }
                : {
                    color: "#777",
                    fontStyle: "italic"
                  }
            }
          >
            Cargo: {alta.descripcion}
          </span>
        </CardHeader>

        {/* Contenido del alta */}
        <CardBody>
          {/* Datos del Cargo */}
          <Row>
            <Col md={12}>
              <h5 className="mb-2">Datos del Cargo</h5>
              <Table size="sm" bordered>
                <thead className="thead-light">
                  <tr>
                    <th className="w88">Cotización</th>
                    <th className="w96">Periodo</th>
                    <th className="w88">Factura</th>
                    <th className="w112">Fecha de Fact.</th>
                    <th className="w96 text-center">Importe</th>
                    <th className="w72">No. Emp.</th>
                    <th>Empleado</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{alta.idCotizacionItem}</td>
                    <td>{formatIsoDate(alta.fechaPeriodo)}</td>
                    <td>{alta.folioFactura}</td>
                    <td>{formatIsoDate(alta.fechaPago)}</td>
                    <td className="text-center">{formatMoney(alta.importe)}</td>
                    <td>{alta.asesorNumeroEmpleado || "N/A"}</td>
                    <td>{alta.asesorNombre || "N/A"}</td>
                  </tr>
                </tbody>
              </Table>
            </Col>
          </Row>

          {/* Datos del Integrante */}
          <Row className="mt-3">
            {!!alta.idMembresiaSocioPersona ? (
              <Col md={12}>
                <h5 className="mb-2">Datos del Integrante</h5>
                {alta.integranteEliminado ||
                  (alta.contieneVentaPeriodo && (
                    <div className="alert alert-warning m-2">
                      No puede descartar las reglas de alta fuera de periodo,
                      porque{" "}
                      {alta.contieneVentaPeriodo
                        ? "la membresía se activó en el mismo, esto no es necesario."
                        : "el integrante está eliminado, se necesita recuperarlo antes."}
                    </div>
                  ))}
                <Table size="sm" bordered>
                  <thead className="thead-light">
                    <tr>
                      <th className="w88">Integrante</th>
                      <th>Nombre</th>
                      <th className="w200">Membresía</th>
                      <th className="w140">Integrante Eliminado</th>
                      <th className="w140">Venta en Periodo</th>
                      {!alta.integranteEliminado &&
                        !alta.contieneVentaPeriodo && (
                          <th className="w100">Forzar reglas</th>
                        )}
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{alta.idPersona}</td>
                      <td>{alta.nombreCompleto}</td>
                      <td>
                        <a
                          href={`/membresias-socios/${alta.idMembresiaSocio}?idClub=${alta.idClubBase}&idPublico=${alta.idPublico}`}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {alta.idPublico} de {alta.clubBase}
                        </a>
                      </td>
                      <td>{alta.integranteEliminado ? "Sí" : "No"}</td>
                      <td>{alta.contieneVentaPeriodo ? "Sí" : "No"}</td>
                      {!alta.integranteEliminado && !alta.contieneVentaPeriodo && (
                        <td>
                          <span
                            id={`resolver-alta-${alta.idCotizacionItem}`}
                            style={{ cursor: "pointer" }}
                            onClick={this.handleOpenResolucionModal}
                          >
                            <FontAwesomeIcon icon={faEdit} color="#007bff" />
                          </span>
                          <UncontrolledTooltip
                            placement="left"
                            target={`resolver-alta-${alta.idCotizacionItem}`}
                          >
                            Aplicar resolución
                          </UncontrolledTooltip>
                        </td>
                      )}
                    </tr>
                  </tbody>
                </Table>
              </Col>
            ) : (
              <Col>
                <div className="alert alert-danger">
                  El cargo no es un alta de integrante.
                </div>
              </Col>
            )}
          </Row>

          {/* Tabla con datos de precálculo */}
          {!!alta.idPrecalculo && (
            <Row className="mt-3">
              <Col md={12}>
                <h5 className="mb-2">Datos de Precálculo</h5>
                <p className="mb-2">
                  El alta de integrante ya pasó por un proceso de precálculo,
                  pero no se pagó.
                </p>
                <Table size="sm" bordered>
                  <tbody>
                    <tr>
                      <th className="w256">Cuenta para alcance</th>
                      <td>{alta.cuentaAlcance ? "Sí" : "No"}</td>
                    </tr>
                    {alta.razonesNoAlcance && alta.razonesNoAlcance.length > 0 && (
                      <tr>
                        <th className="w256">
                          Razones por las que no contó en el alcance
                        </th>
                        <td>
                          {alta.razonesNoAlcance.map((r, i) => (
                            <div key={i}>- {r}</div>
                          ))}
                        </td>
                      </tr>
                    )}
                    {alta.razonesNoComisionAsesor &&
                      alta.razonesNoComisionAsesor.length > 0 && (
                        <tr>
                          <th className="w256">
                            Razones por las que no se comisionó
                          </th>
                          <td>
                            {alta.razonesNoComisionAsesor.map((r, i) => (
                              <div key={i}>- {r}</div>
                            ))}
                          </td>
                        </tr>
                      )}
                    {alta.razonesNoCumpleReglas &&
                      alta.razonesNoCumpleReglas.length > 0 && (
                        <tr>
                          <th className="w256">
                            Razones por las que no se pagó
                          </th>
                          <td>
                            {alta.razonesNoCumpleReglas.map((r, i) => (
                              <div key={i}>- {r}</div>
                            ))}
                          </td>
                        </tr>
                      )}
                  </tbody>
                </Table>
              </Col>
            </Row>
          )}

          {/* Tabla con datos de cargos previos */}
          {alta.cargosPrevios && alta.cargosPrevios.length > 0 && (
            <Row className="mt-3">
              <Col md={12}>
                <h5 className="mb-2">Cargos Previos (Vigencias)</h5>
                <Table size="sm" bordered>
                  <thead className="thead-light">
                    <tr>
                      <th className="w88">Cotización</th>
                      <th className="w200">Membresía</th>
                      <th>Descripción</th>
                      <th className="w200">Mes considerado</th>
                      <th className="w88">Estatus</th>
                    </tr>
                  </thead>
                  <tbody>
                    {alta.cargosPrevios.map((cargo, index) => (
                      <tr key={index}>
                        <td>{cargo.idCotizacionItem}</td>
                        <td>
                          <a
                            href={`/membresias-socios/${cargo.idMembresiaSocio}?idClub=${cargo.idClubBase}&idPublico=${cargo.idPublico}`}
                            target="_blank"
                            rel="noreferrer"
                          >
                            {cargo.idPublico} de {cargo.clubBase}
                          </a>
                        </td>
                        <td>{cargo.descripcion}</td>
                        <td>
                          {formatIsoDate(cargo.fechaInicioVigencia)} -{" "}
                          {formatIsoDate(cargo.fechaFinVigencia)}
                        </td>
                        <td>{cargo.estatus}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Col>
            </Row>
          )}

          {/* Tabla con datos de sustituciones (remplazos) */}
          {alta.sustituciones && alta.sustituciones.length > 0 && (
            <Row className="mt-3">
              <Col md={12}>
                <h5 className="mb-2">Sustituciones (Remplazos)</h5>
                <Table size="sm" bordered>
                  <thead className="thead-light">
                    <tr>
                      <th className="w88">Cotización</th>
                      <th className="w200">Membresía</th>
                      <th className="w200">Persona</th>
                      <th>Descripción</th>
                      <th className="w200">Mes considerado</th>
                    </tr>
                  </thead>
                  <tbody>
                    {alta.sustituciones.map((sustitucion, index) => (
                      <tr key={index}>
                        <td>{sustitucion.idCotizacionItem}</td>
                        <td>
                          <a
                            href={`/membresias-socios/${sustitucion.idMembresiaSocio}?idClub=${sustitucion.idClubBase}&idPublico=${sustitucion.idPublico}`}
                            target="_blank"
                            rel="noreferrer"
                          >
                            {sustitucion.idPublico} de {sustitucion.clubBase}
                          </a>
                        </td>
                        <td>
                          {sustitucion.nombreCompletoDescartada ||
                            sustitucion.nombreCompleto}
                        </td>
                        <td>{sustitucion.descripcion}</td>
                        <td>
                          {formatIsoDate(sustitucion.fechaInicioVigencia)} -{" "}
                          {formatIsoDate(sustitucion.fechaFinVigencia)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Col>
            </Row>
          )}
        </CardBody>

        {/* Modal de Resolución */}
        <FormBuilderModal
          isOpen={this.state.resolucionModalOpen}
          title={`Alta de Integrante en Membresía Existente`}
          message="Marque la casilla para ignorar las reglas de vigencia (desmarcada NO SE PAGA)."
          ok={this.handleSubmitResolucion}
          cancel={this.handleCancelResolucion}
          formConfig={resolucionAltaFormConfig}
          values={{
            pagoForzado: false,
            observaciones: ""
          }}
        />
      </Card>
    );
  }
}
